export class Status {
  static readonly waiting = 'En attente';
  static readonly doing = 'En cours';
  static readonly done = 'Traité';
}
